import { Checkbox } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import * as React from "react";
import { InputProps } from "../../types/InputProps";

class InputCheckbox extends React.Component<InputProps> {
  
  handleChange(event) {
    if ( !this.props.readonly ) {
        this.props.onChange(event.target.checked, event.target);
    }
  }

  public render() {
    return (
      <FormControlLabel        
        control={
          <Checkbox
            disabled={this.props.disabled}
            checked={this.props.value}
            onChange={this.handleChange.bind(this)}
            value={this.props.value ? "true" : ""}
            color={"primary"}
          />
        }
        label={this.props.label}
      />
    );
  }
}

export default InputCheckbox;



// WEBPACK FOOTER //
// ./src/components/InputCheckbox/InputCheckbox.tsx